import { captureSubmitError } from './captureSubmitError'
import { captureSubmitPerformance } from './captureSubmitPerformance'
import { forwardTo } from '../default/forwardTo'
import { verifyCodeInternal } from '../middleware/verifyCodeInternal.js'

/**
 * Submits code and get's user data
 * @param {string} code - The otp code
 * @param {string} phone - The phone
 * @param {string} [redirect] - The success redirect
 * @returns {Promise<boolean|undefined>}
 */
export async function submitCodeInternal(code, phone, redirect) {
  const startTime = performance.now()
  try {
    const verifyNum = phone.startsWith('+1') ? phone : `+1${phone}`
    const success = await verifyCodeInternal(code, verifyNum)

    if (success) {
      captureSubmitPerformance(performance.now() - startTime)
      if (redirect) {
        forwardTo(redirect)
        return
      }
      return true
    }
    return false
  } catch (error) {
    captureSubmitPerformance(performance.now() - startTime)
    captureSubmitError(/** @type {Error} */ (error))
    return false
  }
}
